import type { ModelWithIsCompatibleAndTags } from "../types.ts";

export const countNumberOfOccurencesPerModelTags = (
  models: ModelWithIsCompatibleAndTags[],
) =>
  models
    .flatMapNotNull((model) => model.tags)
    .reduce<Map<string, number>>((accumulator, value) => {
      accumulator.set(value, (accumulator.get(value) ?? 0) + 1);
      return accumulator;
    }, new Map());
